module.exports = __webpack_public_path__ + "media/images/emblems/ArbedoCastione-coat_of_arms-919083c8ea01846349b8f346fba3b958.svg";